import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { checkUser, getData } from "../../../Config/FirebaseMethod";

const Profile = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);

  const [stdData, setStdData] = useState({});

  const {
    firstName,
    lastName,
    email,
    category,
    id,
    gender,
    country,
    city,
    number,
  } = stdData;

  const currentStdData = () => {
    checkUser()
      .then((res) => {
        return getData(`AneeqUllahKhan/`, res)
          .then((success) => {
            setLoading(false);
            setStdData(success);
          })
          .catch((err) => {
            // console.log(err);
          });
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  useEffect(() => {
    currentStdData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Card
                sx={{
                  minWidth: 32 + "%",
                  borderRadius: 3,
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <AccountCircle sx={{ fontSize: 90 }} />
                  </Box>
                  <Typography variant="h6" sx={{ textAlign: "center" }}>
                    {`${
                      firstName.charAt(0).toUpperCase() + firstName.slice(1)
                    } ${lastName.charAt(0).toUpperCase() + lastName.slice(1)}`}
                  </Typography>
                  <Box sx={{ textAlign: "center" }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 3,
                        marginTop: 3,
                      }}
                    >
                      <AdminPanelSettingsIcon />
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {category}
                      </Typography>
                    </Box>
                    <Divider />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 3,
                        marginTop: 3,
                      }}
                    >
                      <PhoneAndroidIcon />
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {number}
                      </Typography>
                    </Box>
                    <Divider />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 3,
                        marginTop: 3,
                      }}
                    >
                      <MarkunreadIcon />
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {email}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card sx={{ minWidth: 32 + "%", borderRadius: 3 }}>
                <CardContent>
                  <Box mt={2}>
                    <Typography variant="h5">Personal Details</Typography>
                    <Box mt={2} />
                    <Divider />
                    <Box mt={2} />
                    <Stack direction="row" spacing={2}>
                      <Typography variant="body1">Admin ID: </Typography>
                      <Typography variant="body1">{id}</Typography>
                    </Stack>
                    <Box mt={2} />
                    <Divider />
                    <Box mt={2} />
                    <Stack direction="row" spacing={2}>
                      <Typography variant="body1">Full Name: </Typography>
                      <Typography variant="body1">{`${
                        firstName.charAt(0).toUpperCase() + firstName.slice(1)
                      } ${
                        lastName.charAt(0).toUpperCase() + lastName.slice(1)
                      }`}</Typography>
                    </Stack>
                    <Box mt={2} />
                    <Divider />
                    <Box mt={2} />
                    <Stack direction="row" spacing={2}>
                      <Typography variant="body1">Country: </Typography>
                      <Typography variant="body1">{country}</Typography>
                    </Stack>
                    <Box mt={2} />
                    <Divider />
                    <Box mt={2} />
                    <Stack direction="row" spacing={2}>
                      <Typography variant="body1">City: </Typography>
                      <Typography variant="body1">{city} </Typography>
                    </Stack>
                    <Box mt={2} />
                    <Divider />
                    <Box mt={2} />
                    <Stack direction="row" spacing={2}>
                      <Typography variant="body1">Gender: </Typography>
                      <Typography variant="body1">{gender}</Typography>
                    </Stack>
                    <Box mt={2} />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default Profile;
